import {Autocomplete, Stack, TextField, Typography} from "@mui/material";
import {ChangeEvent, useMemo} from "react";
import {debounce} from "lodash";
import {FilterItem} from "../../types";
import ClearIcon from "assets/icons/Clear";

interface MixedFilterProps {
  options: FilterItem[];
  value: FilterItem | null;
  onChange: (newValue: FilterItem | null) => void;
  onInputChange: (inputValue: string) => void;
  loading?: boolean;
}

const MixedFilter = ({options, onInputChange, onChange, value, loading}: MixedFilterProps) => {
  const debouncedOnInputChange = useMemo(
    () => debounce((event: ChangeEvent<{}>, inputValue: string) => onInputChange(inputValue), 300),
    [onInputChange]
  );

  return (
    <Stack spacing={1}>
      <Typography variant={'p2'}>Категория</Typography>
      <Autocomplete
        loading={loading}
        options={options}
        value={value}
        onChange={(_, newValue) => onChange(newValue)}
        onInputChange={debouncedOnInputChange}
        getOptionLabel={(option) => `${option.title} (${option.category.title})`}
        clearIcon={
          <ClearIcon sx={{width: 10, height: 10}}/>
        }
        slotProps={{
          clearIndicator: {
            sx: {backgroundColor: '#fff', borderRadius: 2, width: 32, height: 32, visibility: 'visible'},
          },
          popupIndicator: {
            sx: {display: 'none'}
          },
          paper: {
            sx: {
              boxShadow: '8px 8px 32px -4px rgba(0, 19, 57, 0.16)',
              borderRadius: 3,
              '& > ul': {
                p: 2,
                '& > li:not(:last-child)': {
                  mb: 1,
                  borderBottom: '1px solid',
                  borderColor: 'grey.100'
                },
              }
            }
          },
        }}
        sx={(theme) => ({
          '& .MuiOutlinedInput-root': {
            borderRadius: 3,
            backgroundColor: 'background.paper',
            py: 1,
            pl: 1.5,
            '& .MuiOutlinedInput-input': {
              ...theme.typography.p2
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            }
          }
        })}
        renderInput={(params) => (
          <TextField
            {...params}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            <Stack spacing={0.5}>
              <Typography variant={'h5'}>
                {option.category.title}
              </Typography>
              <Typography variant={'p2'}>
                {option.title}
              </Typography>
            </Stack>
          </li>
        )}
      />
    </Stack>
  );
}

export default MixedFilter
